import { Immutable } from "immer";
import React from "react";

import { IReviewsProductTypeID } from "../../../models/nominals";
import { LoadMoreButton } from "../LoadMoreButton";
import { ReviewList } from "../ReviewList";
import { SidebarFilterSection } from "../SidebarFilterSection";
import { TopBar } from "../TopBar";

const buildSideNav = (
    props: {
        displayedProductTypeIDWhitelist: readonly IReviewsProductTypeID[];
        isCondensedView?: boolean;
        showSources: boolean;
        starHasStroke?: boolean;
        writeReviewURL: string;
        onToggleMobileSideNav: () => void;
        mobileSideNavOpen: boolean;
        showAppliedFilters: boolean;
    },
    mobileStatus: boolean,
) => {
    return (
        <SidebarFilterSection
            isMobile={mobileStatus}
            displayedProductTypeIDWhitelist={
                props.displayedProductTypeIDWhitelist
            }
            isCondensedView={props.isCondensedView}
            showProducts={true}
            showSources={props.showSources}
            starHasStroke={props.starHasStroke}
            writeReviewURL={props.writeReviewURL}
            onToggleMobileSideNav={props.onToggleMobileSideNav}
            mobileSideNavOpen={props.mobileSideNavOpen}
            showAppliedFilters={props.showAppliedFilters}
        />
    );
};

const buildReviews = (props: {
    enablePDPLinks: boolean;
    starHasStroke?: boolean;
}) => {
    return (
        <ReviewList
            showSideDate={false}
            enablePDPLinks={props.enablePDPLinks}
            showRecommended={true}
            showVerboseUserInfo={true}
            starHasStroke={props.starHasStroke}
        />
    );
};

const buildLoadMoreButton = (props: { onLoadMore: () => void }) => {
    return <LoadMoreButton onLoadMore={props.onLoadMore} />;
};

const buildReviewModule = (props: {
    mobileSideNavOpen: boolean;
    enablePDPLinks: boolean;
    starHasStroke?: boolean;
    onLoadMore: () => void;
}) => {
    // Hide reviews if filter for mobile is visible
    if (props.mobileSideNavOpen) {
        return null;
    }

    return (
        <div className="customer-review__content">
            <TopBar />
            <div className="customer-review__review-list">
                {buildReviews(props)}
                {buildLoadMoreButton(props)}
            </div>
        </div>
    );
};

export const ReviewsViewer = (
    props: Immutable<{
        displayedProductTypeIDWhitelist: readonly IReviewsProductTypeID[];
        showSources: boolean;
        enablePDPLinks: boolean;
        isCondensedView?: boolean;
        mobileSideNavOpen: boolean;
        showAppliedFilters: boolean;
        writeReviewURL: string;
        starHasStroke?: boolean;
    }> & {
        onLoadMore: () => void;
        onToggleMobileSideNav: () => void;
    },
): React.ReactNode => {
    return (
        <div>
            {buildSideNav(props, true)}
            <div className="customer-review__body" tabIndex={-1}>
                {buildSideNav(props, false)}
                {buildReviewModule(props)}
            </div>
        </div>
    );
};
